import {
  GET_ADMIN_DASHBOARD_DATA_REQUEST,
  GET_ADMIN_DASHBOARD_DATA_SUCCESS,
  GET_ADMIN_DASHBOARD_DATA_FAILURE,
} from "../../../redux/types/auth";

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false,
};

const getAdminDashboardDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };
    case GET_ADMIN_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload && action.payload.data ? action.payload.data : null,
        error: null,
        success: true,
      };
    case GET_ADMIN_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error:
          (action.payload && action.payload.error) ||
          "Failed to load dashboard data",
        success: false,
      };
    default:
      return state;
  }
};

export default getAdminDashboardDataReducer;
